<div class="flex flex-wrap items-center justify-end gap-2 p-2">
  <div>
    <select class="select select-bordered select-sm w-24" (ngModelChange)="changeElements($event)" [(ngModel)]="elements">
      <option [ngValue]="10">10</option>
      <option [ngValue]="50">50</option>
      <option [ngValue]="100">100</option>
      <option [ngValue]="500">500</option>
      <option [ngValue]="1000">1000</option>
    </select>
  </div>

  <div class="join">
    <button
      class="btn btn-sm join-item"
      [disabled]="paginatedResponse.current_page <= 1"
      (click)="changePage(paginatedResponse.current_page - 1)">
      <
    </button>
    <button class="btn btn-sm join-item btn-disabled">
      {{ paginatedResponse.current_page }} / {{ paginatedResponse.last_page }}
    </button>
    <button
      class="btn btn-sm join-item"
      [disabled]="paginatedResponse.current_page >= paginatedResponse.last_page"
      (click)="changePage(paginatedResponse.current_page + 1)">
      >
    </button>
  </div>
</div>
